import React, { useState } from 'react';
import { Container, Card, CardContent, Grid, Typography, Box, Button, IconButton } from '@mui/material';
import Sidebar from '../../components/Sidebar';
import MyButtonGroup from '../../components/MyButtonGroup.js';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import { useHistory } from 'react-router-dom';



const ViewJobs = () => {
  const [flaggedJobs, setFlaggedJobs] = useState({});
  const history = useHistory();

  const handleFlagClick = (index, e) => {
    e.stopPropagation();
    setFlaggedJobs((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handleCardClick = (id) => {
    history.push(`/job/${id}`);
  };

  const jobData = [
    {
      id: 1,
      Designation: "Web Developer",
      company: "ASQI",
      location: "Mumbai, Maharashtra",
      salary: "$15k - $25k",
      postedTime: "1 Month ago",
      profile: "Commercial Manager, 10-12 Years",
      qualification: "Experience in managing large projects...",
      skills: "Leadership, Communication, Finance",
      Description: "Create and maintain responsive, user-centric websites with a focus on front-end design, performance optimization, and seamless user experience."
    },
    {
      id: 2,
      Designation: "Software Engineer",
      company: "iveri",
      location: "Mumbai, Maharashtra",
      salary: "$10k - $15k",
      postedTime: "1 Month ago",
      profile: "Commercial Manager, 10-12 Years",
      qualification: "Experience in managing large projects...",
      skills: "Leadership, Communication, Finance",
      Description: "Design, develop, test, and deploy scalable software solutions, emphasizing problem-solving, code efficiency, and collaboration within cross-functional teams."
    },
  ];

  return (
    <>
      <Sidebar/>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 5 }}>
        <MyButtonGroup />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
        <Button variant="contained" sx={{ backgroundColor: "#272260", fontSize: "10px", textTransform: "none", width: "30%", height: "40px" }}>
          Find Job
        </Button>
      </Box>
      <Container sx={{ mt: 5 }}>
      <Grid mb={1.5}>
        <Typography sx={{ fontSize: '22px', fontWeight: "600 !important" }}>Job Feed</Typography>
      </Grid>
        <Grid container spacing={3}>
          {jobData.map((job) => (
            <Grid item xs={12} key={job.id} onClick={() => handleCardClick(job.id)}>
              <Card sx={{
                border: '1px solid rgba(0,0,0, 0.1)',
                boxShadow: "none",
                cursor: 'pointer',
              }}>
                <CardContent sx={{paddingTop: "0 !important"}}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                    <Box>
                      <Typography variant="h6" component="div" sx={{fontWeight: "550", paddingTop: "5px"}}>
                        {job.Designation}
                      </Typography>
                      <Typography variant="h6" component="div" sx={{ mb: 1 }}>
                        {job.company}
                      </Typography>
                      <Typography variant="body2" component="p">
                        {job.Description}
                      </Typography>
                    </Box>
                    <IconButton 
                      onClick={(e) => handleFlagClick(job.id, e)} 
                      sx={{
                        padding: 0,
                        paddingTop: "9px"
                      }}
                    >
                      <BookmarkIcon 
                        sx={{
                          padding: 0,
                          color: flaggedJobs[job.id] ? 'black' : 'lightgrey',
                          transition: 'color 0.3s ease',
                        }}
                      />
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
};

export default ViewJobs;
